// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Map = require("rescript/lib/js/belt_Map.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Webapi__Dom__HtmlElement = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__HtmlElement.bs.js");
var CustomMap$SmartcutsMacros = require("../../bs-macros-extension/src/CustomMap.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var GenericTree$SmartcutsMacros = require("../../bs-node-suffix-tree/src/GenericTree.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var DOM__HtmlElement$SmartcutsMacros = require("../../bs-macros-extension/src/DOM__HtmlElement.bs.js");
var STEM__Interfaces$SmartcutsMacros = require("./STEM__Interfaces.bs.js");
var DataExtraction__DataRegion$SmartcutsMacros = require("./DataExtraction__DataRegion.bs.js");

var defaultFilters = [
  {
    TAG: /* ByNodeFrequencyAndEdgeLength */0,
    _0: {
      nodeFrequencyEqualsOrGreaterThan: 2,
      substringLengthEqualsOrGreaterThan: 2
    }
  },
  {
    TAG: /* ByLongestCommonSubSequence */1,
    _0: {
      recordValidationRate: 0.05,
      patternValidationRate: 0.6
    }
  },
  /* ByTreeStructure */0,
  /* ByRepetition */1
];

function make(param) {
  return {
          identifiersByHtmlTagPath: {
            contents: Curry._1(CustomMap$SmartcutsMacros.MapHtmlTagPath.make, undefined)
          },
          nextHtmlTagPathIdentifier: {
            contents: STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.init
          }
        };
}

function identifierForHtmlTagPath(generator, htmlTagPath) {
  var identifiersByHtmlTagPath = generator.identifiersByHtmlTagPath.contents;
  var identifier = Belt_Map.get(identifiersByHtmlTagPath, htmlTagPath);
  if (identifier !== undefined) {
    return Caml_option.valFromOption(identifier);
  }
  var nextHtmlTagPathIdentifier = generator.nextHtmlTagPathIdentifier.contents;
  generator.nextHtmlTagPathIdentifier.contents = STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.increment(nextHtmlTagPathIdentifier);
  generator.identifiersByHtmlTagPath.contents = Belt_Map.set(identifiersByHtmlTagPath, htmlTagPath, nextHtmlTagPathIdentifier);
  return nextHtmlTagPathIdentifier;
}

var HtmlTagPathIdentifierGenerator = {
  make: make,
  identifierForHtmlTagPath: identifierForHtmlTagPath
};

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "tags",
                Decco.arrayToJson(Decco.stringToJson, v.tags)
              ],
              [
                "htmlTagPathIdentifier",
                STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode(v.htmlTagPathIdentifier)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var tags = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tags"), null));
  if (tags.TAG === /* Ok */0) {
    var htmlTagPathIdentifier = STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlTagPathIdentifier"), null));
    if (htmlTagPathIdentifier.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                tags: tags._0,
                htmlTagPathIdentifier: htmlTagPathIdentifier._0
              }
            };
    }
    var e = htmlTagPathIdentifier._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".htmlTagPathIdentifier" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = tags._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".tags" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function toTagPathString(param) {
  return param.tags.join(">");
}

function forHtmlElement(htmlTagPathIdentifierGenerator, previousTags, includeTagComponentsOpt, htmlElement) {
  var includeTagComponents = includeTagComponentsOpt !== undefined ? includeTagComponentsOpt : [/* TagName */0];
  var currTag = Belt_Array.reduce(includeTagComponents, "", (function (tag, component) {
          if (component) {
            return tag + Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.flatMap(Caml_option.nullable_to_opt(htmlElement.getAttribute("class")), OptionUtils$SmartcutsMacros.optionalString), (function (classValue) {
                              return "[class=" + (classValue.trim().replace(/\n/g, " ").replace(/\s\s+/g, " ").split(" ").sort().join(" ") + "]");
                            })), "");
          } else {
            return htmlElement.tagName.toLowerCase();
          }
        }));
  var tags = Belt_Array.concat(previousTags, [currTag]);
  var htmlTagPathIdentifier = identifierForHtmlTagPath(htmlTagPathIdentifierGenerator, tags);
  return {
          tags: tags,
          htmlTagPathIdentifier: htmlTagPathIdentifier
        };
}

function isSame(param, param$1) {
  return Caml_obj.caml_equal(param.htmlTagPathIdentifier, param$1.htmlTagPathIdentifier);
}

function compare(param, param$1) {
  return STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.compare(param.htmlTagPathIdentifier, param$1.htmlTagPathIdentifier);
}

function doesMatchHtmlTagPathIdentifier(tagPath, htmlTagPathIdentifier) {
  return Caml_obj.caml_equal(htmlTagPathIdentifier, tagPath.htmlTagPathIdentifier);
}

var HtmlTagPath = {
  t_encode: t_encode,
  t_decode: t_decode,
  toTagPathString: toTagPathString,
  forHtmlElement: forHtmlElement,
  isSame: isSame,
  compare: compare,
  doesMatchHtmlTagPathIdentifier: doesMatchHtmlTagPathIdentifier
};

function t_encode$1(encoder_htmlElement, v) {
  return Js_dict.fromArray([
              [
                "tagPath",
                t_encode(v.tagPath)
              ],
              [
                "parentId",
                Decco.optionToJson(STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode, v.parentId)
              ],
              [
                "htmlElement",
                Curry._1(encoder_htmlElement, v.htmlElement)
              ]
            ]);
}

function t_decode$1(decoder_htmlElement, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var tagPath = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tagPath"), null));
  if (tagPath.TAG === /* Ok */0) {
    var parentId = Decco.optionFromJson(STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "parentId"), null));
    if (parentId.TAG === /* Ok */0) {
      var htmlElement = Curry._1(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlElement"), null));
      if (htmlElement.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  tagPath: tagPath._0,
                  parentId: parentId._0,
                  htmlElement: htmlElement._0
                }
              };
      }
      var e = htmlElement._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".htmlElement" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = parentId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".parentId" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = tagPath._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".tagPath" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function mapHtmlElement(mapHtmlElement$1, param) {
  return {
          tagPath: param.tagPath,
          parentId: param.parentId,
          htmlElement: Curry._1(mapHtmlElement$1, param.htmlElement)
        };
}

var Generic = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  mapHtmlElement: mapHtmlElement
};

function forHtmlElement$1(parentId, htmlTagPathIdentifierGenerator, previousTags, htmlElement) {
  var tagPath = forHtmlElement(htmlTagPathIdentifierGenerator, previousTags, undefined, htmlElement);
  return {
          tagPath: tagPath,
          parentId: parentId,
          htmlElement: htmlElement
        };
}

var NodeWithPath = {
  Generic: Generic,
  forHtmlElement: forHtmlElement$1
};

function t_encode$2(encoder_htmlElement, v) {
  return Js_dict.fromArray([
              [
                "htmlTagPathByHtmlTagPathIdentifier",
                Curry._2(STEM__Interfaces$SmartcutsMacros.MapHtmlTagPathIdentifier.t_encode, t_encode, v.htmlTagPathByHtmlTagPathIdentifier)
              ],
              [
                "webPageSequence",
                Decco.arrayToJson(STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode, v.webPageSequence)
              ],
              [
                "allNodesInWebPageSequence",
                Decco.arrayToJson((function (param) {
                        return t_encode$1(encoder_htmlElement, param);
                      }), v.allNodesInWebPageSequence)
              ],
              [
                "encodedWebPageSequence",
                STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.t_encode(v.encodedWebPageSequence)
              ],
              [
                "htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier",
                Curry._2(STEM__Interfaces$SmartcutsMacros.MapEncodedHtmlTagPathIdentifier.t_encode, STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode, v.htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier)
              ],
              [
                "htmlTagPathIdentifierParentMap",
                Curry._2(STEM__Interfaces$SmartcutsMacros.MapHtmlTagPathIdentifier.t_encode, STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode, v.htmlTagPathIdentifierParentMap)
              ]
            ]);
}

function t_decode$2(decoder_htmlElement, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var htmlTagPathByHtmlTagPathIdentifier = Curry._2(STEM__Interfaces$SmartcutsMacros.MapHtmlTagPathIdentifier.t_decode, t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlTagPathByHtmlTagPathIdentifier"), null));
  if (htmlTagPathByHtmlTagPathIdentifier.TAG === /* Ok */0) {
    var webPageSequence = Decco.arrayFromJson(STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "webPageSequence"), null));
    if (webPageSequence.TAG === /* Ok */0) {
      var allNodesInWebPageSequence = Decco.arrayFromJson((function (param) {
              return t_decode$1(decoder_htmlElement, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "allNodesInWebPageSequence"), null));
      if (allNodesInWebPageSequence.TAG === /* Ok */0) {
        var encodedWebPageSequence = STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "encodedWebPageSequence"), null));
        if (encodedWebPageSequence.TAG === /* Ok */0) {
          var htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier = Curry._2(STEM__Interfaces$SmartcutsMacros.MapEncodedHtmlTagPathIdentifier.t_decode, STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier"), null));
          if (htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier.TAG === /* Ok */0) {
            var htmlTagPathIdentifierParentMap = Curry._2(STEM__Interfaces$SmartcutsMacros.MapHtmlTagPathIdentifier.t_decode, STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlTagPathIdentifierParentMap"), null));
            if (htmlTagPathIdentifierParentMap.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        htmlTagPathByHtmlTagPathIdentifier: htmlTagPathByHtmlTagPathIdentifier._0,
                        webPageSequence: webPageSequence._0,
                        allNodesInWebPageSequence: allNodesInWebPageSequence._0,
                        encodedWebPageSequence: encodedWebPageSequence._0,
                        htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier: htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier._0,
                        htmlTagPathIdentifierParentMap: htmlTagPathIdentifierParentMap._0
                      }
                    };
            }
            var e = htmlTagPathIdentifierParentMap._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".htmlTagPathIdentifierParentMap" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = encodedWebPageSequence._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".encodedWebPageSequence" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = allNodesInWebPageSequence._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".allNodesInWebPageSequence" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = webPageSequence._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".webPageSequence" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = htmlTagPathByHtmlTagPathIdentifier._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".htmlTagPathByHtmlTagPathIdentifier" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function mapHtmlElement$1(mapHtmlElement$2, param) {
  return {
          htmlTagPathByHtmlTagPathIdentifier: param.htmlTagPathByHtmlTagPathIdentifier,
          webPageSequence: param.webPageSequence,
          allNodesInWebPageSequence: Belt_Array.map(param.allNodesInWebPageSequence, (function (param) {
                  return mapHtmlElement(mapHtmlElement$2, param);
                })),
          encodedWebPageSequence: param.encodedWebPageSequence,
          htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier: param.htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier,
          htmlTagPathIdentifierParentMap: param.htmlTagPathIdentifierParentMap
        };
}

var Generic$1 = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  mapHtmlElement: mapHtmlElement$1
};

function shouldIgnoreElementAlreadyCollectedDataRecords(subtreesWithCollectedDataRecords, htmlElement) {
  return Belt_Array.some(subtreesWithCollectedDataRecords, (function (htmlElement$p) {
                return htmlElement === htmlElement$p;
              }));
}

function fromDocument(subtreesWithCollectedDataRecords) {
  var htmlTagPathIdentifierGenerator = make(undefined);
  var arg = Array.prototype.slice.call(document.childNodes);
  var arg$1 = (function (param) {
        return ArrayUtils$SmartcutsMacros.shortcut(param, arg);
      })(function (node) {
        return Belt_Option.flatMap(Curry._1(Webapi__Dom__HtmlElement.ofNode, node), (function (htmlElement) {
                      var tagName = htmlElement.tagName;
                      if (tagName !== "HTML") {
                        return ;
                      }
                      var arg = [];
                      return forHtmlElement$1(undefined, htmlTagPathIdentifierGenerator, arg, htmlElement);
                    }));
      });
  var htmlNodeWithPath = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
      })("Expect to get <html> element from document's childNodes");
  return GenericTree$SmartcutsMacros.depthFirst((function (param) {
                var htmlElement = param.htmlElement;
                var tagPath = param.tagPath;
                var pathToSvgElement = tagPath.tags;
                if (pathToSvgElement.length === 2) {
                  var match = pathToSvgElement[0];
                  if (match === "html") {
                    var match$1 = pathToSvgElement[1];
                    if (match$1 === "head") {
                      return [];
                    }
                    
                  }
                  
                }
                if (Caml_obj.caml_equal(ArrayUtils$SmartcutsMacros.last(pathToSvgElement), "svg")) {
                  return [];
                }
                if (Caml_obj.caml_equal(ArrayUtils$SmartcutsMacros.last(pathToSvgElement), "style")) {
                  return [];
                }
                if (Caml_obj.caml_equal(ArrayUtils$SmartcutsMacros.last(pathToSvgElement), "script")) {
                  return [];
                }
                if (htmlElement.id === "smartcuts-htmlPreprocessing") {
                  return [];
                }
                if (shouldIgnoreElementAlreadyCollectedDataRecords(subtreesWithCollectedDataRecords, htmlElement)) {
                  return [];
                }
                var parentId = tagPath.htmlTagPathIdentifier;
                var partial_arg = tagPath.tags;
                var partial_arg$1 = Caml_option.some(parentId);
                return Belt_Array.map(Belt_Array.keepMap(Array.prototype.slice.call(htmlElement.childNodes), Webapi__Dom__HtmlElement.ofNode), (function (param) {
                              return forHtmlElement$1(partial_arg$1, htmlTagPathIdentifierGenerator, partial_arg, param);
                            }));
              }), [], (function (node, result) {
                return Belt_Array.concat(result, [node]);
              }), htmlNodeWithPath);
}

function toWebPageSequence(allNodes) {
  return Belt_Array.map(allNodes, (function (param) {
                return param.tagPath.htmlTagPathIdentifier;
              }));
}

function getHtmlElementsForRange(allNodes, param) {
  var startsAt = param.startsAt;
  return Belt_Array.map(Belt_Array.slice(allNodes, startsAt, param.endsAt - startsAt | 0), (function (param) {
                return param.htmlElement;
              }));
}

function getIndexesForNodesThatMatchHtpiSequence(allNodes, htmlTagPathIdentifierSequence) {
  return Belt_Option.getWithDefault(Belt_Option.map(ArrayUtils$SmartcutsMacros.splitAtFirst(htmlTagPathIdentifierSequence), (function (param) {
                    var nextHtmlTagPathIdentifierSequence = param[1];
                    var firstHtmlTagPathIdentifier = param[0];
                    var len = nextHtmlTagPathIdentifierSequence.length;
                    return Belt_Array.keep(ArrayUtils$SmartcutsMacros.filterMapi((function (index, param) {
                                      if (Caml_obj.caml_equal(firstHtmlTagPathIdentifier, param.tagPath.htmlTagPathIdentifier)) {
                                        return index;
                                      }
                                      
                                    }), allNodes), (function (startsAt) {
                                  if ((startsAt + len | 0) >= allNodes.length) {
                                    return false;
                                  }
                                  var offset = startsAt + 1 | 0;
                                  return ArrayUtils$SmartcutsMacros.everyWithIndex(nextHtmlTagPathIdentifierSequence, (function (indexInNextHtpiSequence, htmlTagPathIdentifier) {
                                                var nodeWithPath = Caml_array.get(allNodes, offset + indexInNextHtpiSequence | 0);
                                                return Caml_obj.caml_equal(htmlTagPathIdentifier, nodeWithPath.tagPath.htmlTagPathIdentifier);
                                              }));
                                }));
                  })), []);
}

var AllNodes = {
  fromDocument: fromDocument,
  toWebPageSequence: toWebPageSequence,
  getHtmlElementsForRange: getHtmlElementsForRange,
  getIndexesForNodesThatMatchHtpiSequence: getIndexesForNodesThatMatchHtpiSequence
};

function doArrayOfTagsMatch(tags_1, tags_2) {
  if (tags_1.length === tags_2.length) {
    return Belt_Array.every2(tags_1, tags_2, (function (tag_a, tab_b) {
                  return tag_a === tab_b;
                }));
  } else {
    return false;
  }
}

function forSequenceOfTagPathsAppliedToAllNodes(allNodes, sequenceOfTagPathArrays) {
  return Belt_Option.getWithDefault(Belt_Option.map(ArrayUtils$SmartcutsMacros.splitAtFirst(sequenceOfTagPathArrays), (function (param) {
                    var nextSequenceOfTagPathArrays = param[1];
                    var firstTagPathArray = param[0];
                    return Belt_Array.map(Belt_Array.map(ArrayUtils$SmartcutsMacros.filterMapi((function (index, param) {
                                          var tags = param.tagPath.tags;
                                          if (doArrayOfTagsMatch(tags, firstTagPathArray)) {
                                            console.warn("MATCHES TAGS", tags);
                                            return index;
                                          }
                                          
                                        }), allNodes), (function (startsAt) {
                                      var offset = startsAt + 1 | 0;
                                      var match = Belt_Array.reduceWithIndex(nextSequenceOfTagPathArrays, [
                                            [0],
                                            offset
                                          ], (function (param, tagPathArray, indexInNextSequence) {
                                              var offset = param[1];
                                              var matchingIndexes = param[0];
                                              var currNodeTagPathArray = Caml_array.get(allNodes, offset).tagPath.tags;
                                              if (doArrayOfTagsMatch(tagPathArray, currNodeTagPathArray)) {
                                                return [
                                                        $$Array.append(matchingIndexes, [indexInNextSequence]),
                                                        offset + 1 | 0
                                                      ];
                                              } else {
                                                return [
                                                        matchingIndexes,
                                                        offset
                                                      ];
                                              }
                                            }));
                                      return [
                                              startsAt,
                                              match[0]
                                            ];
                                    })), (function (param) {
                                  var matchingIndexes = param[1];
                                  var startsAt = param[0];
                                  var endsAt = startsAt + matchingIndexes.length | 0;
                                  var score = matchingIndexes.length / sequenceOfTagPathArrays.length;
                                  return [
                                          {
                                            startsAt: startsAt,
                                            endsAt: endsAt
                                          },
                                          score
                                        ];
                                }));
                  })), []);
}

function toArrayOfRangesWithHighestScoreChosenPerStartsAt(rangesWithScores) {
  return Belt_MapString.valuesToArray(Belt_MapString.map(ArrayUtils$SmartcutsMacros.groupBy((function (param) {
                        return String(param[0].startsAt);
                      }), rangesWithScores), (function (rangesWithScores) {
                    var match = ArrayUtils$SmartcutsMacros.splitAtFirstExn("Expected at least one range with score", rangesWithScores);
                    return Belt_Array.reduce(match[1], match[0], (function (rangeWithMaxScore, currRangeWithScore) {
                                    if (currRangeWithScore[1] > rangeWithMaxScore[1]) {
                                      return currRangeWithScore;
                                    } else {
                                      return rangeWithMaxScore;
                                    }
                                  }))[0];
                  })));
}

var RangesWithScores = {
  doArrayOfTagsMatch: doArrayOfTagsMatch,
  forSequenceOfTagPathsAppliedToAllNodes: forSequenceOfTagPathsAppliedToAllNodes,
  toArrayOfRangesWithHighestScoreChosenPerStartsAt: toArrayOfRangesWithHighestScoreChosenPerStartsAt
};

function forAllNodesInDocument(subtreesWithCollectedDataRecords) {
  var allNodes = fromDocument(subtreesWithCollectedDataRecords);
  var htmlTagPathByHtmlTagPathIdentifier = Curry._1(STEM__Interfaces$SmartcutsMacros.MapHtmlTagPathIdentifier.fromArray, Belt_Array.map(allNodes, (function (param) {
              var tagPath = param.tagPath;
              return [
                      tagPath.htmlTagPathIdentifier,
                      tagPath
                    ];
            })));
  var allNodesInWebPageSequence = Belt_Array.keep(allNodes, (function (param) {
          var htmlElement = param.htmlElement;
          if (DOM__HtmlElement$SmartcutsMacros.isVisibleOnPage(htmlElement)) {
            return !shouldIgnoreElementAlreadyCollectedDataRecords(subtreesWithCollectedDataRecords, htmlElement);
          } else {
            return false;
          }
        }));
  var webPageSequence = toWebPageSequence(allNodesInWebPageSequence);
  var match = STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.encodeFromHtmlTagPathIdentifierSequence(webPageSequence);
  var htmlTagPathIdentifierParentMap = Curry._1(STEM__Interfaces$SmartcutsMacros.MapHtmlTagPathIdentifier.fromArray, Belt_Array.keepMap(allNodes, (function (param) {
              var htmlTagPathIdentifier = param.tagPath.htmlTagPathIdentifier;
              return Belt_Option.map(param.parentId, (function (parentId) {
                            return [
                                    htmlTagPathIdentifier,
                                    parentId
                                  ];
                          }));
            })));
  return {
          htmlTagPathByHtmlTagPathIdentifier: htmlTagPathByHtmlTagPathIdentifier,
          webPageSequence: webPageSequence,
          allNodesInWebPageSequence: allNodesInWebPageSequence,
          encodedWebPageSequence: match[0],
          htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier: match[1],
          htmlTagPathIdentifierParentMap: htmlTagPathIdentifierParentMap
        };
}

function extractSignal(client) {
  var allHtmlTagPathIdentifiers = [];
  Belt_Array.forEach(Belt_Map.keysToArray(client.htmlTagPathByHtmlTagPathIdentifier), (function (htmlTagPathIdentifier) {
          var index = STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.toInt(htmlTagPathIdentifier);
          allHtmlTagPathIdentifiers[index] = htmlTagPathIdentifier;
          
        }));
  var encodedHtmlTagPathIdentifierString = STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.makeText(STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.encodeFromHtmlTagPathIdentifierSequence(allHtmlTagPathIdentifiers)[0]);
  return {
          encodedWebPageSequenceString: STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.makeText(client.encodedWebPageSequence),
          encodedHtmlTagPathIdentifierString: encodedHtmlTagPathIdentifierString,
          htmlTagPathIdentifierParentMap: client.htmlTagPathIdentifierParentMap
        };
}

function toConcatenatedString(htmlTagPathIdentifierSequence) {
  return Belt_Array.map(htmlTagPathIdentifierSequence, STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.toString).join(",");
}

function splitAtHtmlTagPathIdentifier(sequence, htmlTagPathIdentifier) {
  var splitSequence = function (htmlTagPathIdentifierSequence) {
    var len = htmlTagPathIdentifierSequence.length;
    var end_ = htmlTagPathIdentifierSequence.indexOf(htmlTagPathIdentifier);
    if (end_ === -1) {
      return {
              hd: htmlTagPathIdentifierSequence,
              tl: /* [] */0
            };
    }
    if (end_ !== 0) {
      return Belt_List.add(splitSequence(htmlTagPathIdentifierSequence.slice(end_, len)), htmlTagPathIdentifierSequence.slice(0, end_));
    }
    var end_$1 = htmlTagPathIdentifierSequence.indexOf(htmlTagPathIdentifier, 1);
    if (end_$1 !== -1) {
      return Belt_List.add(splitSequence(htmlTagPathIdentifierSequence.slice(end_$1, len)), htmlTagPathIdentifierSequence.slice(0, end_$1));
    } else {
      return {
              hd: htmlTagPathIdentifierSequence,
              tl: /* [] */0
            };
    }
  };
  return splitSequence(sequence);
}

var HtmlTagPathIdentifierSequence = {
  toConcatenatedString: toConcatenatedString,
  splitAtHtmlTagPathIdentifier: splitAtHtmlTagPathIdentifier
};

function isAncestorOf($$this, id1, id2) {
  var _id = id2;
  while(true) {
    var id = _id;
    var parentId = Belt_Map.get($$this.htmlTagPathIdentifierParentMap, id);
    if (parentId === undefined) {
      return false;
    }
    var parentId$1 = Caml_option.valFromOption(parentId);
    if (Caml_obj.caml_equal(parentId$1, id1)) {
      return true;
    }
    _id = parentId$1;
    continue ;
  };
}

function length(client) {
  return client.allNodesInWebPageSequence.length;
}

function getRange(client, param) {
  var startsAt = param.startsAt;
  return Belt_Array.slice(client.allNodesInWebPageSequence, startsAt, param.endsAt - startsAt | 0);
}

function sliceToEnd(client, offset) {
  return Belt_Array.sliceToEnd(client.allNodesInWebPageSequence, offset);
}

function isNodeAncestorOf(client, node1, node2) {
  return isAncestorOf(client, node1.tagPath.htmlTagPathIdentifier, node2.tagPath.htmlTagPathIdentifier);
}

function isNodeSiblingOf(_client, node1, node2) {
  return DOM__HtmlElement$SmartcutsMacros.isSiblingOf(node1.htmlElement, node2.htmlElement);
}

var include = DataExtraction__DataRegion$SmartcutsMacros.Make({
      length: length,
      getRange: getRange,
      sliceToEnd: sliceToEnd,
      isNodeAncestorOf: isNodeAncestorOf,
      isNodeSiblingOf: isNodeSiblingOf
    });

var $$Range = include.$$Range;

var getNodes = include.getNodes;

var maybeAdditionalRange = include.maybeAdditionalRange;

function getHtmlElements(dataRegion, client) {
  return Belt_Array.map(Curry._2(getNodes, client, dataRegion), (function (param) {
                return param.htmlElement;
              }));
}

function getHtmlTagPathIdentifierSequence(param, client) {
  var match = param.fullRange;
  var startsAt = match.startsAt;
  return Belt_Array.slice(client.webPageSequence, startsAt, match.endsAt - startsAt | 0);
}

function findOccurrencesAsRanges(htmlTagPathIdentifierSequence, client) {
  var len = htmlTagPathIdentifierSequence.length;
  return Belt_Array.map(getIndexesForNodesThatMatchHtpiSequence(client.allNodesInWebPageSequence, htmlTagPathIdentifierSequence), (function (startsAt) {
                var endsAt = startsAt + len | 0;
                return {
                        startsAt: startsAt,
                        endsAt: endsAt
                      };
              }));
}

function mergeIntoDataRegions(ranges, client) {
  return Belt_Array.reduce(ranges, [], (function (dataRegions, range) {
                var maybeReplaceDataRegionAtIndex = ArrayUtils$SmartcutsMacros.shortcutWithIndex((function (dataRegion, index) {
                        var dataRegion$p = DataExtraction__DataRegion$SmartcutsMacros.maybeMergeWithRange(dataRegion, range);
                        if (dataRegion$p !== undefined) {
                          return [
                                  dataRegion$p,
                                  index
                                ];
                        } else if (Belt_Array.every(getHtmlElementsForRange(client.allNodesInWebPageSequence, range), (function (childElement) {
                                  return Belt_Array.some(getHtmlElements(dataRegion, client), (function (htmlElement) {
                                                return htmlElement.contains(childElement);
                                              }));
                                }))) {
                          return [
                                  {
                                    fullRange: {
                                      startsAt: Math.min(dataRegion.fullRange.startsAt, range.startsAt),
                                      endsAt: Math.max(dataRegion.fullRange.endsAt, range.endsAt)
                                    },
                                    rangeList: Belt_List.add(dataRegion.rangeList, range),
                                    additionalRange: dataRegion.additionalRange
                                  },
                                  index
                                ];
                        } else {
                          return ;
                        }
                      }), dataRegions);
                if (maybeReplaceDataRegionAtIndex !== undefined) {
                  return ArrayUtils$SmartcutsMacros.replaceAtIndex(dataRegions, maybeReplaceDataRegionAtIndex[1], maybeReplaceDataRegionAtIndex[0]);
                } else {
                  return Belt_Array.concat(dataRegions, [DataExtraction__DataRegion$SmartcutsMacros.fromRange(range)]);
                }
              }));
}

function maybeAppendAdditionalRanges(dataRegions, client) {
  return Belt_Array.reduce(Belt_Array.map(dataRegions, (function (dataRegion) {
                    var additionalRange = Curry._2(maybeAdditionalRange, client, dataRegion);
                    if (additionalRange === undefined) {
                      return dataRegion;
                    }
                    if (Belt_Array.keepMap(dataRegions, (function (nextRegion) {
                              return Curry._2($$Range.mergeIfOverlap, nextRegion.fullRange, additionalRange);
                            })).length !== 0) {
                      console.warn("Ignoring additionalRange that bleeds into nextDataRegion");
                      return dataRegion;
                    }
                    var init = dataRegion.fullRange;
                    return {
                            fullRange: {
                              startsAt: init.startsAt,
                              endsAt: additionalRange.endsAt
                            },
                            rangeList: dataRegion.rangeList,
                            additionalRange: additionalRange
                          };
                  })), [], (function (dataRecords, dataRecord) {
                var maybeReplaceDataRecordAtIndex = ArrayUtils$SmartcutsMacros.shortcutWithIndex((function (dataRecord$p, index) {
                        return Belt_Option.map(DataExtraction__DataRegion$SmartcutsMacros.maybeMergeWith(dataRecord$p, dataRecord), (function (dataRecord$p) {
                                      return [
                                              dataRecord$p,
                                              index
                                            ];
                                    }));
                      }), dataRecords);
                if (maybeReplaceDataRecordAtIndex !== undefined) {
                  return ArrayUtils$SmartcutsMacros.replaceAtIndex(dataRecords, maybeReplaceDataRecordAtIndex[1], maybeReplaceDataRecordAtIndex[0]);
                } else {
                  return Belt_Array.concat(dataRecords, [dataRecord]);
                }
              }));
}

function groupByFirstNode(dataRegions, client) {
  return Belt_MapString.valuesToArray(ArrayUtils$SmartcutsMacros.groupBy((function (dataRegion) {
                    return STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.toString(Caml_array.get(client.allNodesInWebPageSequence, dataRegion.fullRange.startsAt).tagPath.htmlTagPathIdentifier);
                  }), dataRegions));
}

var DataRegion = {
  $$Range: $$Range,
  getNodes: getNodes,
  maybeAdditionalRange: maybeAdditionalRange,
  getHtmlElements: getHtmlElements,
  getHtmlTagPathIdentifierSequence: getHtmlTagPathIdentifierSequence,
  findOccurrencesAsRanges: findOccurrencesAsRanges,
  mergeIntoDataRegions: mergeIntoDataRegions,
  maybeAppendAdditionalRanges: maybeAppendAdditionalRanges,
  groupByFirstNode: groupByFirstNode
};

function processPatternsIntoDataRegionGroups(client, uniqueEncodedHtmlTagPathIdentifierStrings) {
  var arg = Belt_Array.map(uniqueEncodedHtmlTagPathIdentifierStrings, (function (substring) {
          return STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.decodeToHtmlTagPathIdentifierSequence(STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.fromText(substring), client.htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier);
        }));
  return groupByFirstNode(maybeAppendAdditionalRanges(mergeIntoDataRegions((function (param) {
                          return ArrayUtils$SmartcutsMacros.flatMap(param, arg);
                        })(function (param) {
                          return findOccurrencesAsRanges(param, client);
                        }), client), client), client);
}

exports.defaultFilters = defaultFilters;
exports.HtmlTagPathIdentifierGenerator = HtmlTagPathIdentifierGenerator;
exports.HtmlTagPath = HtmlTagPath;
exports.NodeWithPath = NodeWithPath;
exports.Generic = Generic$1;
exports.AllNodes = AllNodes;
exports.RangesWithScores = RangesWithScores;
exports.forAllNodesInDocument = forAllNodesInDocument;
exports.extractSignal = extractSignal;
exports.HtmlTagPathIdentifierSequence = HtmlTagPathIdentifierSequence;
exports.isAncestorOf = isAncestorOf;
exports.DataRegion = DataRegion;
exports.processPatternsIntoDataRegionGroups = processPatternsIntoDataRegionGroups;
/* include Not a pure module */
